import { Button, Form, Input, Skeleton, Spin } from 'antd';
import { FormikProvider } from 'formik';
import { GoStopwatch } from 'react-icons/go';
import { useSelector } from 'react-redux';

import { CoreBadge } from '../../../RnRCommonComponent';
import EmployeePicker from '../../../RnRCommonComponent/EmployeePicker/EmployeePickerComponent.jsx';
import { datediff } from '../../../nominatedRewards/utils';
import formatDateInTable from '../../../rewardsAndRecognitionHelper/CommonDate.js';
import FormPreview from 'src/new-form-builder/FormPreview.jsx';

import './style.scss';

const NominateEmployeePresentation = ({
	selectedEmployee,
	setSelectedEmployee,
	searchedEmployeeData,
	setSearchedEmployeeData,
	formik,
	badgeDetails,
	endDate,
	nominationLoading,
	hasCustomForm,
	customFormDefinition,
	customFormLoading,
	customFormInstance,
}) => {
	const { setFieldValue, values, handleSubmit, errors, touched } = formik;
	const { TextArea } = Input;
	const currentUser = useSelector((state) => state?.user?.currentUser);
	const allowSelfNominations =
		badgeDetails?.allowSelfNomination ||
		currentUser?.company?.recognitionSettings?.allowSelfNominations ||
		false;

	return (
		<FormikProvider value={formik}>
			<div>
				<div className="physical-reward-modal col-12 p-0">
					<div className="row physical-reward-container">
						<div className="col-lg-4 mt-4">
							<div className="physical-reward-badge">
								{badgeDetails && (
									<CoreBadge
										badgeType={badgeDetails?.badgeType?.code}
										badgeIcon={badgeDetails?.icon?.code}
										label={badgeDetails?.label}
										color={badgeDetails?.color}
										gradientColor={badgeDetails?.gradientColor}
										shape={badgeDetails?.shape}
										badgeRotation={badgeDetails?.badgeRotation}
										customImageSignedUrl={badgeDetails?.customImageSignedUrl}
										labelColor={badgeDetails?.labelColor}
										customIconSignedUrl={badgeDetails?.customIconSignedUrl}
									/>
								)}
								<div className="physical-reward-details">
									<div className="physical-reward-details-title">
										{badgeDetails?.name}
									</div>
									<p className="physical-reward-text">
										{badgeDetails?.description}
									</p>

									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											columnGap: '10px',
											marginTop: '20px',
										}}
									>
										<div>
											<GoStopwatch size={'30px'} color="#E75FA8" />
										</div>
										<div>
											<div>
												{datediff(new Date(), new Date(endDate))} Days Remaining
											</div>
											<div>Ends on {formatDateInTable(endDate)}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-8 mt-4">
							<Form layout="vertical" className="custom-form-group">
								<Form.Item
									label="Select Employee To Nominate"
									style={{ marginBottom: 16, padding: '0 12px' }}
									validateStatus={touched.nomineeId && errors.nomineeId ? 'error' : ''}
									help={touched.nomineeId && errors.nomineeId}
								>
									<EmployeePicker
										selectedEmployee={selectedEmployee}
										setSelectedEmployee={setSelectedEmployee}
										setSearchedEmployeeData={setSearchedEmployeeData}
										nominationPicker={true}
										showCurrentUserInSearch={allowSelfNominations}
										placeholder="Search for an employee..."
										style={{ width: '100%' }}
										className="custom-input choose-reward-input"
										notFoundContent="Try searching by Name, Job Title, or Location"
									/>
								</Form.Item>
								{!hasCustomForm && (
									<Form.Item
										label={<>Enter Reason To Nominate <span className="custom-required">(required)</span></>}
										style={{ marginBottom: 16, padding: '0 12px' }}
										validateStatus={touched.nominationReason && errors.nominationReason ? 'error' : ''}
										help={touched.nominationReason && errors.nominationReason}
									>
										<TextArea
											className="custom-input"
											rows={5}
											style={{ width: '100%' }}
											onChange={(event) => {
												setFieldValue('nominationReason', event.target.value);
											}}
											onBlur={() => formik.setFieldTouched('nominationReason', true)}
										/>
									</Form.Item>
								)}
								{customFormLoading && (
									<div style={{ marginTop: 16 }}>
										<Skeleton paragraph={{ rows: 3 }} />
									</div>
								)}
								{!customFormLoading && customFormDefinition && (
									<FormPreview
										elements={customFormDefinition.elements || []}
										formMetadata={customFormDefinition.metadata || {}}
										formType="custom"
										isPreview={false}
										formFromProps={customFormInstance}
										disabled={false}
									/>
								)}
								<div className="d-flex justify-content-center w-100">
									<Form.Item className="mt-3 mb-0">
										{nominationLoading ? (
											<Spin />
										) : (
											<Button
												type="primary"
												onClick={() => {
													handleSubmit();
												}}
											>
												Nominate
											</Button>
										)}
									</Form.Item>
								</div>
							</Form>
						</div>
					</div>
					<div className="row"></div>
				</div>
			</div>
		</FormikProvider>
	);
};

export default NominateEmployeePresentation;
